var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[(
            (_vm.authState != 'signedIn' && !_vm.routerLayout) ||
            _vm.platformLoading ||
            _vm.loadError
        )?[_c('LoggedOutView',{attrs:{"app-loading":_vm.platformLoading,"load-error":_vm.loadError},on:{"aws-login":_vm.login}})]:[_c('v-main',{staticStyle:{"padding-top":"0"}},[_c('router-view',{attrs:{"logged-in":_vm.authState == 'signedIn'}})],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }